// import cogoToast from 'cogo-toast';
import React from "react";
import { toast } from 'react-toastify';

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken }
      } = store.getState();
      const modulename = sessionStorage.getItem('module');

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
        config.headers.modulename = modulename;
      }

      return config;
    },
    err => Promise.reject(err)
  );

  // Response interceptor for API calls
  axios.interceptors.response.use(function (response) {
    if (response.headers['curr-version'] !== process.env.REACT_APP_VERSION) { // if server version newer
      window.localStorage.setItem('version-update-needed', 'true'); // set version update item so can refresh app later
    };
    return response
  }, async function (error) {
    console.log(error);
    console.log(error.response);

    // const originalRequest = error.config;
    if (error.response && error.response.status === 401) {
      sessionStorage.clear();
      window.location.href = "/logout";
    } else if (error.response && error.response.status === 500) {
      if (error.response.data && error.response.data.error) {
        console.log(error.response.data.error);
        toast.error(<div><strong>Error Encountered</strong><br /> {error.response.data.error} </div>);
      }
    }

    let errorString = error?.response?.data;
    console.log("🚀 ~ file: setupAxios.js:44 ~ axios.interceptors.response.use ~ errorString:", error)
    console.log("🚀 ~ file: setupAxios.js:44 ~ axios.interceptors.response.use ~ errorString:", errorString)
    if (
      error.request.responseType === 'blob' &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf('json') !== -1
    ) {
      const resp = await error?.response?.data?.text();
      toast.error(<div><strong>Error Encountered</strong><br /> {resp} </div>);
    }
    return Promise.reject(console.error(error?.response?.data));
  });
}
